import { showToast } from '@/components/base/Toast';
import { heroCovers } from '@/mocks/home';

const STATS = [
  { value: '1,280+', label: '收录写真套图' },
  { value: '96', label: 'cos 视频条目' },
  { value: '每日', label: '资源更新节奏' },
];

export default function Hero() {
  return (
    <section id="home" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 pb-16 pt-14 md:px-8 md:pb-20 md:pt-20">
        <div className="mx-auto max-w-[1200px]">
          <div className="flex flex-col gap-10 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-2xl">
              <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500" />
                <span className="text-xs font-medium tracking-wider text-primary-700">
                  SECRETARY ROLEPLAY · 视觉资源库
                </span>
              </div>
              <h1 className="font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
                善良的女秘书角色扮演
                <span className="mt-2 block text-lg font-semibold text-secondary-600 md:text-2xl">
                  写真集 · cos视频 · 私拍套图，一站收藏
                </span>
              </h1>
              <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
                围绕善良的女秘书角色扮演，整理制服写真、场景短片与私拍套图等多类视觉资源，
                按热度与更新节奏持续补充，方便你集中浏览与收藏欣赏。
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#albums"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
                >
                  <i className="ri-gallery-line text-base" />
                  浏览写真集
                </a>
                <a
                  href="#ranking"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
                >
                  <i className="ri-fire-line text-base text-accent-600" />
                  查看本周热度榜
                </a>
              </div>
            </div>

            <div className="flex gap-8 border-t border-background-300 pt-6 lg:border-none lg:pt-0">
              {STATS.map((stat) => (
                <div key={stat.label} className="flex flex-col">
                  <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                    {stat.value}
                  </span>
                  <span className="mt-1 text-xs text-foreground-600">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {heroCovers.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => showToast('静态展示：详情页暂未开放')}
                className="group relative block h-[420px] w-full overflow-hidden rounded-lg border border-background-300 bg-background-200 text-left md:h-[480px]"
              >
                <img
                  src={item.cover}
                  alt={`${item.title} - 善良的女秘书角色扮演写真封面`}
                  title={`${item.title} - 善良的女秘书 角色扮演 写真集`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {item.tag}
                </span>
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-heading text-lg font-bold text-background-50">{item.title}</h3>
                  <div className="mt-2 flex items-center gap-4 text-xs text-background-200">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-accent-400" />
                      热度 {item.hot}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-bookmark-line" />
                      收藏入口
                    </span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}